"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'access.status.active': 'Aktywny',
    'access.status.inactive': 'Nieaktywny',
};
